import { render, staticRenderFns } from "./fabric-canvas.vue?vue&type=template&id=3ad4e882&scoped=true&"
import script from "./fabric-canvas.vue?vue&type=script&lang=ts&"
export * from "./fabric-canvas.vue?vue&type=script&lang=ts&"
import style0 from "./fabric-canvas.vue?vue&type=style&index=0&id=3ad4e882&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad4e882",
  null
  
)

export default component.exports